
import React from "react";
import { FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
import { useLanguage } from "@/context/LanguageContext";
import { UseFormReturn } from "react-hook-form";
import { sdgsData } from "@/data/sdgs";

interface SdgSelectorProps {
  form: UseFormReturn<any>;
  disabled?: boolean;
}

const SdgSelector: React.FC<SdgSelectorProps> = ({ form, disabled = false }) => {
  const { language } = useLanguage();

  return (
    <FormField
      control={form.control}
      name="sdgId"
      render={({ field }) => (
        <FormItem>
          <FormLabel>{language === "en" ? "SDG" : "أهداف التنمية المستدامة"}</FormLabel>
          <FormControl>
            <select
              className="flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
              {...field}
              disabled={disabled}
            >
              {sdgsData.map((sdg) => (
                <option key={sdg.id} value={sdg.id}>
                  {sdg.id}: {language === "en" ? sdg.title.en : sdg.title.ar}
                </option>
              ))}
            </select>
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};

export default SdgSelector;
